import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { ptBR } from '@mui/x-date-pickers/locales';
import { toZonedTime } from 'date-fns-tz';
import moment from 'moment';
import 'moment-timezone';
import 'moment/dist/locale/pt-br';
import React, { useState } from 'react';
import { JAZZ_TIME_ZONE } from 'utils/jazzTimeZone';
import { DatePickerStyled, slotProps } from './styles';
import { CustomDatePickerProps } from './types';

moment.tz.setDefault(JAZZ_TIME_ZONE);
moment.locale('pt-br');

const asMoment = (v: moment.Moment | string | null | undefined) => moment.isMoment(v) ? v : v ? moment(v) : null;

export const DatePicker: React.FC<CustomDatePickerProps> = ({
  value,
  shouldDisableDate = () => false,
  disablePast = false,
  disableFuture,
  onChangeDatePicker,
  minDate,
  maxDate,
  label,
}) => {
  const [open, setOpen] = useState(false);

  const applyChange = (m: moment.Moment | null) => {
    if (!m) {
      onChangeDatePicker?.(null);
      return;
    }
    const zoned = toZonedTime(m.toDate(), JAZZ_TIME_ZONE);
    const momentZoned = moment(zoned);

    onChangeDatePicker?.(momentZoned);
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      adapterLocale="pt-br"
      localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <DatePickerStyled
        format="DD/MM/YYYY"
        value={asMoment(value)}
        onChange={applyChange}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        onAccept={applyChange}
        desktopModeMediaQuery="theme.breakpoints.up('md')"
        label={label}
        views={['year', 'month', 'day']}
        slotProps={{
          ...slotProps,
          openPickerButton: {
            sx: { display: 'none' },
          },
          textField: {
            ...slotProps?.textField,
            onClick: () => setOpen(true),
          },
        }}
        disablePast={disablePast}
        shouldDisableDate={shouldDisableDate}
        minDate={asMoment(minDate) ?? undefined}
        maxDate={asMoment(maxDate) ?? undefined}
        orientation="portrait"
        disableFuture={disableFuture}
      />
    </LocalizationProvider>
  );
};
